import InputKeyList from '../const/inputKeyList';
import { isObject } from './getTypeofItem';

export const validateForm = ({ state, store, isWebBooker }) => {
  const QRInputKeyList = InputKeyList[isWebBooker ? 'web' : 'quest'];

  if (state.rideId && !state.accountCreation?.flow) return true;

  let currStore = { ...state };
  if (
    (isWebBooker && currStore.step === 9) ||
    (((isWebBooker && currStore.step === 8) || (!isWebBooker && currStore.step === 6)) &&
      currStore.payment?.description &&
      Object.keys(currStore.serviceTypesAndAmounts || {}).length !== 0)
  )
    return true;

  if (state.accountCreation?.flow) currStore = store.getState();

  let currInputKeyList = null;
  if (state.accountCreation?.flow) {
    const { flow, step } = state.accountCreation || {};
    currInputKeyList = InputKeyList.account[flow][step];
  } else currInputKeyList = QRInputKeyList[currStore.step];

  return currInputKeyList?.reduce((isValid, key) => {
    currStore =
      key === 'phone' ||
      key === 'code' ||
      key === 'name' ||
      key === 'email' ||
      key === 'password' ||
      key === 'rePassword'
        ? store.getState()
        : { ...state };

    if (
      key === 'privacyTerms' ||
      key === 'downloadApp' ||
      key === 'rideLater' ||
      key === 'paymentList' ||
      key === 'downloadAppWeb'
    )
      return isValid;
    if (key === currStore.error) return false;
    if (isObject(currStore[key])) {
      if (Object.keys(currStore[key]).length) {
        if (currStore[key].required) return isValid && currStore[key].value;
        if (key === 'phone' || key === 'email' || key === 'password') return isValid && currStore[key].isValid;
        return isValid;
      } else return isValid && false;
    }
    if (key === 'rePassword') return isValid && currStore['password']?.isValid;

    return isValid && !!currStore[key];
  }, true);
};
